import * as types from './types';
import { loading, handleErrorException } from 'State/actions';
import { createToast, toastType } from 'Common/ToastHelper';
import { getDefaultDD } from '../../helpers/EditDailyDepositHelpers';

export const getInitialData = (siteId, servingDT, isSupper) => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch({ type: types.EDIT_DAILY_DEPOSIT_CLEAR_STATE });
    dispatch(loading(types.EDIT_DAILY_DEPOSIT_FETCHING, true));

    try {
      let response = await MPWWebApi.getGeneric(`DailyDeposit/GetPrimarySites`);
      dispatch({
        type: types.EDIT_DAILY_DEPOSIT_GET_SITES,
        payload: response.data.Data,
      });

      if (siteId) {
        const response = await MPWWebApi.getGeneric(
          `DailyDeposit/GetModifyDailyDeposit/${siteId}/${servingDT}/${
            isSupper ? '1' : '0'
          }`
        );

        dispatch({
          type: types.EDIT_DAILY_DEPOSIT_GET_DATA,
          payload: response.data.Data,
        });
      } else {
        dispatch({
          type: types.EDIT_DAILY_DEPOSIT_GET_DATA,
          payload: getDefaultDD(isSupper),
        });
      }
    } catch (error) {
      dispatch(
        handleErrorException(error, types.EDIT_DAILY_DEPOSIT_FETCH_ERROR, {
          Message: 'There was a problem loading the page.',
        })
      );
    }

    dispatch(loading(types.EDIT_DAILY_DEPOSIT_FETCHING, false));
  };
};

export const writeDeposit = values => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.EDIT_DAILY_DEPOSIT_LOADING, true));

    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        `DailyDeposit/WriteModifyDailyDeposit`,
        values
      );

      createToast(toastType.success, 'Success', 'Deposit saved successfully.');
      dispatch({
        type: types.EDIT_DAILY_DEPOSIT_NEW_ID,
        payload: response.data.Data,
      });
      dispatch({
        type: types.EDIT_DAILY_DEPOSIT_GET_DATA,
        payload: values,
      });
    } catch (error) {
      dispatch(
        handleErrorException(error, types.EDIT_DAILY_DEPOSIT_FETCH_ERROR, {
          Message:
            'There was a problem saving the Modified Daily Deposit, please try again.',
        })
      );
    }

    dispatch(loading(types.EDIT_DAILY_DEPOSIT_LOADING, false));
  };
};

export const clearError = () => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch({
      type: types.EDIT_DAILY_DEPOSIT_FETCH_ERROR,
      payload: null,
    });
  };
};



// WEBPACK FOOTER //
// ./src/pages/modifydailydeposits/state/editdailydeposit/actions.js